
$(document).ready(function(){
	$(".poBox-input").hide();
	$(".comment-input").hide();
	$(".material-icons.minus").hide();
	
	$(".poBox-show").click(function(){
		console.log('heyy');
		$(".poBox-input").slideToggle('200','linear');
		$(".poBox-show .material-icons.minus").toggle();
		$(".poBox-show .material-icons.plus").toggle();
	});

	$(".comment-show").click(function(){
		$(".comment-input").slideToggle('200','linear');
		$(".comment-show .material-icons.minus").toggle();
		$(".comment-show .material-icons.plus").toggle();
	});
});